import { Component, Input, OnInit } from '@angular/core';
import { AdditionalCoverageBoxComponent } from '@shared/components/additional-coverage-box/additional-coverage-box.component';
import { SkipperFormModel } from '@shared/models/forms/skipper-form.model';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { PaginatorModule } from 'primeng/paginator';
import { takeUntil } from 'rxjs';
import { unsubscribeMixin } from '@shared/mixin/unsubscribe.mixin';

@Component({
  selector: 'app-skipper-rechtsschutz',
  templateUrl: './skipper-rechtsschutz.component.html',
  imports: [
    AdditionalCoverageBoxComponent,
    PaginatorModule,
    ReactiveFormsModule
  ],
  styleUrl: './skipper-rechtsschutz.component.scss'
})
export class SkipperRechtsschutzComponent extends unsubscribeMixin() implements OnInit {
  @Input() form!: FormGroup<SkipperFormModel>;

  ngOnInit(): void {
    this.form.controls.skipperRechtsschutz.controls.isKundeAdditionalCharterVertragsRechtsschutzSelected
      .valueChanges.pipe(takeUntil(this.componentDestroyed$)).subscribe((value) => {
      if (value) {
        this.form.controls.skipperRechtsschutz.controls.isSelbstbehaltSelected.setValue(true);
        this.form.controls.skipperRechtsschutz.controls.isSelbstbehaltSelected.disable();
      } else {
        this.form.controls.skipperRechtsschutz.controls.isSelbstbehaltSelected.enable();
      }
    });
  }
}